import { displayError } from '../helpers';
import { printReceiptVoucher } from '../services/ReceiptVoucherServices';
import { openPdfInApp } from './openPdfInApp';

async function parseApiError(error) {
    const responseData = error?.response?.data;
    if (responseData instanceof Blob) {
        try {
            const text = await responseData.text();
            try {
                return JSON.parse(text);
            } catch (parseError) {
                return { message: text || 'Failed to generate receipt voucher PDF.' };
            }
        } catch (readError) {
            return { message: 'Failed to generate receipt voucher PDF.' };
        }
    }
    return responseData || error;
}

export function fetchAndShowReceiptVoucherPdf(cookies, receiptId, options = {}) {
    return printReceiptVoucher(cookies, receiptId)
        .then((pdfResponse) => {
            openPdfInApp(pdfResponse, {
                title: options.title || 'Receipt Voucher',
                downloadFileName: options.downloadFileName,
                onClose: options.onClose,
            });
        })
        .catch(async (error) => {
            const parsedError = await parseApiError(error);
            displayError(
                parsedError || { message: 'Failed to generate receipt voucher PDF.' },
                options.errorTitle || 'Print Failed',
            );
        });
}
